<template lang="pug">
  div
    Sidenav(
      :class="{'sideNav--small': small}"
      disableOpenBtn=true)

      //- Logo
      img.sidenav__logo(:src="require(`@/assets/img/${logo}`)")

      //- Menu
      div(@click="closeSidenav")
        router-link.sidenav__link.border-top(:to="{ name: 'home' }")
          van-icon.sidenav__icon(name="home")
          | {{ $t('sidenav.home') }}

        router-link.sidenav__link(:to="{ name: 'schedules' }")
          van-icon.sidenav__icon(name="schedule")
          | {{ $t('sidenav.schedule') }}

        router-link.sidenav__link(:to="{ name: 'scenes' }" v-if="scenes")
          van-icon.sidenav__icon(name="video")
          | {{ $t('sidenav.scenes') }}

        router-link.sidenav__link(:to="{ name: 'weather' }" v-if="weather")
          van-icon.sidenav__icon(name="heating")
          | {{ $t('sidenav.weather') }}

        router-link.sidenav__link(:to="{ name: 'units' }")
          van-icon.sidenav__icon(name="units")
          | {{ $t('sidenav.units') }}

        router-link.sidenav__link(:to="{ name: 'users' }")
          van-icon.sidenav__icon(name="users")
          | {{ $t('sidenav.users') }}

        router-link.sidenav__link(
          :to="{ name: 'devices' }" v-if="!isDemo && devices && appName === 'dknna'")
          van-icon.sidenav__icon(name="device")
          | {{ $t('sidenav.devices') }}

        router-link.sidenav__link.border-bottom(:to="{ name: 'settings' }")
          van-icon.sidenav__icon(name="setting")
          | {{ $t('sidenav.settings') }}

        router-link.sidenav__link(:to="{ name: 'account' }")
          van-icon.sidenav__icon(name="user")
          | {{ $t('sidenav.account') }}

        router-link.sidenav__link(:to="{ name: 'addUnit' }" v-if="isMobile")
          van-icon.sidenav__icon(name="more")
          | {{ $t('sidenav.addUnit') }}

        router-link.sidenav__link(:to="{ name: 'support' }")
          van-icon.sidenav__icon(name="support")
          | {{ $t('sidenav.support') }}

        a.sidenav__link.border-bottom(@click="confirmLogout" v-if="!isDemo")
          van-icon.sidenav__icon(name="logout")
          | {{ $t('sidenav.logout') }}

        a.sidenav__link.border-bottom(@click="exitDemo" v-if="isDemo")
          van-icon.sidenav__icon(name="logout")
          | {{ $t('sidenav.exitDemo') }}

      //- Powered by
      .sidenav__powered
        | {{ $t('sidenav.powered') }}
        img(src="@/assets/img/airzone.svg")
    router-view
</template>

<script>
import i18n from '@/locales/i18n';
import { mapGetters, mapActions } from 'vuex';
import UserService from '@/services/user.service';
import { getErrorId } from '@/services/error.service';
import Sidenav from '@/components/Sidenav.vue';
import { CONFIG, IS_MOBILE, APPNAME } from '@/app.config';

export default {
  components: {
    Sidenav,
  },
  data() {
    return {
      small: screen.height <= 645, // eslint-disable-line
      scenes: CONFIG.SCENES,
      weather: CONFIG.WEATHER,
      devices: CONFIG.DEVICES,
      iMobile: IS_MOBILE,
      appName: APPNAME,
    };
  },
  computed: {
    ...mapGetters({
      isDemo: 'globalModule/isDemo',
      appMode: 'globalModule/getAppMode',
    }),

    logo() {
      switch (this.appMode) {
        case 'DEV':
          return 'logoDEV.svg';
        case 'PRE':
          return 'logoPRE.svg';
        default:
          return 'logo.svg';
      }
    },
  },
  methods: {
    ...mapActions({
      closeSidenav: 'globalModule/closeSidenav',
      deleteUser: 'userModule/deleteUser',
      setDemo: 'globalModule/setDemo',
    }),

    /**
     * Confirma si realmente quiere cerrar la sesión del usuario
     */
    confirmLogout() {
      this.$dialog
        .confirm({
          message: i18n.t('auth.logoutConfirm'),
        })
        .then(() => {
          this.logout();
        });
    },

    /**
     * Cierra la sesión del usuario
     */
    async logout() {
      try {
        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        await UserService.logout();
      } catch (error) {
        getErrorId(error);
        UserService.cleanData();
      } finally {
        this.$toast.clear();
        this.deleteUser();
        this.$router.push({
          name: 'login',
          query: { reaseon: 'logout' },
        });
      }
    },

    /**
     * Salir del modo demo
     */
    exitDemo() {
      this.setDemo(false);
      this.$router.push({ name: 'login' });
    },
  },

  created() {
    this.isMobile = IS_MOBILE;
    console.log('Es movil', this.isMobile);
    console.log('App', this.appName);
    console.log('process env', process.env);
  },
};
</script>
